const observerConfig = { attributes: false, childList: true, subtree: true };
const vObserverConfig = { attributes: true, childList: true, subtree: true, attributeFilter: ["data-qb-pdelay"] };

let observer = null;
let rprotect = 0;
let v_observer = null;



function process_option_changeover(){
  //  console.log('option changeover processing');
  //console.log($("input.ymq-shopify-option:checked"));
  let opts_set = $("input.ymq-shopify-option:checked");
 // console.log(opts_set);
  let ptitle = "";
  if (opts_set.length == 0) {
 //   console.log("using native");
    opts_set = $("input.single-option-selector__radio:checked");
 //   console.log(opts_set);
    
//    window.alert("no option selected");
  	}
  if(opts_set.length == 0) {console.log("Options not located");}
  
  for (let i = 0; i < opts_set.length; i++){
  //	console.log(opts_set[i].value);
    if (i > 0) ptitle = ptitle + " / "
    ptitle = ptitle + opts_set[i].value;
  	}
 // console.log(ptitle);
  vindex = " ";
  for (let i = 0; i < window.meta.product.variants.length; i++){
    if (window.meta.product.variants[i].public_title == ptitle) {
    	vindex = window.meta.product.variants[i].id;
      	break;
    	}
  	}
  if(vindex == 0){console.log ("Variant not found by title:" + ptitle);}
 // console.log(vindex);
//  let p_delay = " ";
  p_delay = qb_options.av.get(vindex);
//  if(typeof(p_delay) === "undefined")){p_delay = qb_options.av[vindex];}
  if (typeof(window.asl_country)==="undefined"){
  }
  else{
  if(window.asl_country()=="US" || window.asl_country()=="CA"){
  	$(".qb-unit-of-measure").show();
  	}
  }

 // console.log("p_delay:" + p_delay);
  if(typeof(p_delay) === "undefined"){console.log("p_delay:" + p_delay);console.log("undefined pdelay for variant:["+ptitle+"] index:"+vindex);console.log(qb_options);}
  else {
  if (p_delay.charAt(0) =="*"){
	$(".qb-in-stock-text").hide();
    $(".qb-out-stock-text").text(qb_options.outstock_text.replace("-XYZ-",p_delay.substr(1)));
    $(".qb-out-stock-text").show();
  	}
  else{
	$(".qb-out-stock-text").hide();
    $(".qb-in-stock-text").text(qb_options.instock_text.replace("-XYZ-",p_delay));
    $(".qb-in-stock-text").show();
  	}
  }
    
}


const init_pdelay = function (mutationsList){

  	console.log("init pdelay");
 //   console.log($(".qb-in-stock-text"));
    v_observer.disconnect();
  	process_option_changeover();
	
};

function init_qb_product_extras(){
  		l = $(".product-images:first>:not([class])").length;
          if(l > 0){
  		
            if($("#qb-description-d").length > 0){ /*console.log ("already added");*/}
            else {
	            console.log(qb_options);
              //Add dimensions
              if(qb_options.default_height > " " && qb_options.default_width > " " ){
              	let option_text = qb_options.product_dimensions_text.replace("__height__", qb_options.default_height);
                option_text = option_text.replace("__width__", qb_options.default_width);
                console.log(option_text);
              	$("#qb-description-m .qb-prod-dimensions").html(option_text);       
              }                                                                             
              //Copy the mobile description to desktop
              let dscr ="<div id=qb-description-d>" + $("#qb-description-m").html() + "</div>";
              $(".product-images:first>:not([class]):first").append(dscr);
              let phdr = $("h1 .qb-product-design").html();
              phdr = '<span class="qb-product-design-title">' + phdr + '</span>';
              //console.log(phdr);
              $("#qb-description-d").prepend(phdr);
              $("#qb-description-m").prepend(phdr);
//                $(".product-images:first").append(dscr);
              //Pre-production warning and other custom actions upon option changover 
              process_option_changeover();
              //Add listener for the pre-production warning and other custom actions upon option changover
			   $(".selection-wrapper.variant").on("change","input.ymq-shopify-option",function(){
                 process_option_changeover();
   				});
               }
          }

}

const img_callback = function(mutationsList, xobserver) {
  if(rprotect == 0) {
    for(const mutation of mutationsList) {
        if (mutation.type === 'childList') {
//            console.log('A child node has been added or removed.');
//          console.log(mutation.addedNodes);
//          console.log('*******');
          l = $(".product-images:first>:not([class])").length;
//          l = $(".images-container:first>:not([class])").length;
          if(l > 0){
            
//            console.log('no class' + l);
//            console.log($(".product-images:first>:not([class])").css("clear"));
            xobserver.disconnect();
            observer.disconnect();
            rprotect = 1;
//!!!            
            init_qb_product_extras();
            observer.disconnect();
          	}
        }
    }
  }
};


function initObservers(){
   imgNode = $(".product-images:first")[0];
   
  observer = new MutationObserver(img_callback);
  observer.observe(imgNode, observerConfig);
   
   selNode = $(".selection-wrapper.variant")[0];
   console.log("selNode");
   console.log(selNode);
   v_observer = new MutationObserver(init_pdelay);
   v_observer.observe(selNode, vObserverConfig);

}

function initBoth(){
  initObservers();
  init_qb_product_extras();

}

if(document.readyState =="loading"){

    window.addEventListener('DOMContentLoaded', function() {
      (function( $ ) {
//      $(document).ready(function(){
      $(function(){
 if ($("body").attr("data-template")=="product"){
 /* window.alert("product page");*/
   console.log("loading...");
  initObservers();
 }
  
});
   })(jQuery);
    });
}
else{
 
if(typeof jQuery === 'undefined'){
  var pre_jq = document.querySelectorAll('script[src="https://cdn.shopify.com/s/files/1/0570/6491/5100/t/2/assets/jquery-3.4.1.min.js"]');
  if( pre_jq.length <= 0){
    var qb_jq = document.createElement("script"); 
    qb_jq.src = "https://cdn.shopify.com/s/files/1/0570/6491/5100/t/2/assets/jquery-3.4.1.min.js";
    qb_jq.addEventListener ("load", initBoth);    
    qb_jq.type = 'text/javascript';
  	qb_jq.async = true;
    document.getElementsByTagName("head")[0].appendChild(qb_jq);
  }
   else{
 //   console.log("RM2");
  pre_jq[0].addEventListener ("load", initBoth);
  }
  
} 
else {
initBoth();
}
  
  
}


